import {
  Collapse,
  Grid,
  Icon,
  IconButton,
  MenuItem,
  TableCell,
  TableRow,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import FilterList from "../../../partials/filterList";
import Header from "../../../partials/header";
import InputFormat from "../../../partials/inputForm";
import TableFormat from "../../../partials/TableFormat";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import { formatDatetime } from "../../../utils/setting";
import DialogConfirm from "../../dialog";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import EditForm from "../edit";
import { styles } from "./styles";
const headCells = [
  {
    key: "isCustomer",
    numeric: false,
    disablePadding: false,
    label: "visitor_is_customer",
  },
  { key: "name", numeric: false, disablePadding: false, label: "visitor_name" },
  {
    key: "phone",
    numeric: false,
    disablePadding: false,
    label: "visitor_phone",
  },
  {
    key: "email",
    numeric: false,
    disablePadding: false,
    label: "visitor_email",
  },
  { key: "ip", numeric: false, disablePadding: false, label: "visitor_ip" },
  {
    key: "createdAt",
    numeric: false,
    disablePadding: false,
    label: "visitor_createdAt",
  },
];

class Visitors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      orderBy: "createdAt",
      selected: [],
      collapse: [],
      fromType: "",
      from: moment().subtract(3, "months").startOf("month").valueOf(),
      to: moment().endOf("month").valueOf(),
      listFilter: {
        fromType: ""
      },
    };
  }

  getList = async (data, applyFilter = true) => {
    const { fromType, from, to, listFilter } = this.state;
    let { page, rowsPerPage } = this.mTable.state;
    let filter = {};
    if (fromType) {
      filter = { fromType: fromType };
      listFilter["fromType"] = fromType;
    }
    this.loading.startLoading();
    this.setState({ listFilter })
    if (applyFilter)
      await this.props.getList({
        snackbar: this.snackbar,
        page: page,
        limit: rowsPerPage,
        ...data,
      });
    else
      await this.props.getList({
        snackbar: this.snackbar,
        page: page,
        limit: rowsPerPage,
        filter: filter,
        from: from ? moment(from).startOf("day").valueOf() : "",
        to: to ? moment(to).endOf("day").valueOf() : "",
        ...data,
      });
    this.loading.stopLoading();
  };
  showFilter = (event) => {
    this.FilterList.toggleDrawer(true, event);
  };
  clearFilter = () => {
    let _this = this;
    this.setState(
      {
        fromType: "",
        from: moment().subtract(3, "months").startOf("month").valueOf(),
        to: moment().endOf("month").valueOf(),
        categoryId: "",
        listFilter: {
          fromType: ""
        },
      },
      function () {
        _this.getList();
      }
    );
  };
  handleFilter = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleFilterDate = (from, to) => {
    const _this = this;
    this.setState(
      {
        from: from ? moment(from).startOf("day").valueOf() : "",
        to: to ? moment(to).endOf("day").valueOf() : "",
      },
      function () {
        _this.getList();
      }
    );
  };
  handleOpenCollapes = (id) => {
    let { collapse } = this.state;
    collapse = collapse.map((e, index) => {
      if (index !== id) return false;
      else return e;
    });
    collapse[id] = !collapse[id];
    this.setState({ collapse: collapse });
  };
  handleDelete = async (selected = []) => {
    let { t } = this.props;
    if (selected && selected.length) {
      let check = await this.props.delete({
        snackbar: this.snackbar,
        _id: selected,
      });
      if (check.code === 1) {
        this.mSnackbar.handleClick(
          t("contact_listcontact_delete_successfully")
        );
        return true;
      } else {
        this.mSnackbar.handleClick(
          t("contact_listcontact_delete_unsuccessfully")
        );
        return false;
      }
    } else {
      this.mSnackbar.handleClick(t("pls_select_item"));
      return false;
    }
  };
  renderCollapse = (row, index) => {
    const { classes, list_visitor } = this.props;
    const { collapse = [] } = this.state;

    return (
      <TableRow style={{ height: 0 }} key={index}>
        <TableCell
          colSpan={10}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index] ? true : false} unmountOnExit>
            <EditForm
              item={index}
              visitor={list_visitor[index]}
              handleClose={() => this.handleOpenCollapes(index)}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  renderIsCustomer = (row) => {
    return (
      <React.Fragment>
        <IconButton
          style={row.isCustomer === true ? { opacity: 1 } : { opacity: 0 }}
        >
          <Icon color="secondary">grade</Icon>
        </IconButton>
      </React.Fragment>
    );
  };
  render() {
    const {
      classes,
      t,
      list_visitor = [],
      total,
      count,
      list_fromType,
    } = this.props;
    const { from, to, fromType, collapse, listFilter } = this.state;

    return (
      <div>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <DialogConfirm
          onRef={(dialog) => (this.mDialog = dialog)}
          disagree={t("visitor_cancel")}
          agree={t("visitor_ok")}
          title={t("visitor_notice")}
          content={t("visitor_do_you_want_to_delete_this_visitor")}
          action={this.delete}
        />
        <FilterList
          onRef={(id) => (this.FilterList = id)}
          clearFilter={this.clearFilter}
          getList={this.getList}
        >
          {/* <Grid container spacing={3}> */}
          <Grid item xs={12} sm={12}>
            <InputFormat
              select
              label={t("contact_fromType")}
              fullWidth
              value={fromType}
              displayEmpty
              onChange={this.handleFilter}
              name="fromType"
              margin="normal"
              disableUnderline={false}
            >
              <MenuItem value="">{t("visitor_pls_select")}</MenuItem>
              {list_fromType &&
                list_fromType.map((e) => {
                  return (
                    <MenuItem
                      classes={{
                        root: classes.textCapitalize,
                      }}
                      value={e}
                    >
                      {e}
                    </MenuItem>
                  );
                })}
            </InputFormat>
          </Grid>
          {/* </Grid>  */}
        </FilterList>
        <Header
          session={t("sidebar_cms")}
          title={t("visitor_list_visitors")}
          showFilterDate={true}
          handleFilterDate={this.handleFilterDate}
          from={from}
          to={to}
        />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          orderBy=""
          contentDialog={t("visitor_do_you_want_to_delete_this_visitor")}
          onDelete={this.handleDelete}
          title={t("visitor_list_visitors")}
          showFilter={true}
          openFilter={(e) => this.showFilter(e)}
          listFilter={listFilter}
          showActionToolbar={false}
          placeholder={t("visitor_search_by_customer_name_phone_email")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getList}
          rows={list_visitor.map((row, index) => {
            const parsePhone = _parsePhoneNumber(
              row.countryCode,
              row.countryCode
            );
            return {
              id: row._id,
              isCustomer: this.renderIsCustomer(row),
              name: row.name,
              email: row.email,
              phone: parsePhone.isValid
                ? parsePhone.format_internal
                : row.countryCode + "" + row.phone,
              ip: row.ip,
              createdAt: formatDatetime(row.createdAt),
            };
          })}
        />
      </div>
    );
  }
}

Visitors.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  list_visitor: state.visitors.list_visitor,
  list_fromType: state.visitors.list_fromType,
  total: state.visitors.total,
});

const mapDispatch = (dispatch) => ({
  getList: dispatch.visitors.getList,
  delete: dispatch.visitors.delete,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Visitors)));
